import {BaseModel} from '../base';
import {day} from '../../services/day';
import {bbTimeZone} from '../../utils/time_zone';

class DayModel extends BaseModel {

    constructor(data) {
        super(...arguments);
        this.string_date = this.date;
        this.date = moment.tz(this.date, bbTimeZone.getCompany());
    }

    /**
     * @description
     * Get day date
     *
     * @returns {date} The returned day
     */
    day() {
        return this.date.date();
    }

    /**
     * @description
     * Get off by month
     *
     * @returns {date} The returned off
     */
    off(month) {
        return this.date.month() !== month;
    }

    /**
     * @description
     * Get class in according of month
     *
     * @returns {string} The returned class
     */
    class(month) {
        let str = '';
        if (this.date.month() < month) {
            str += 'off off-prev';
        }
        if (this.date.month() > month) {
            str += 'off off-next';
        }
        if (this.spaces === 0) {
            str += ' not-avail';
        }
        return str;
    }

    static $query(prms) {
        return day.query(prms);
    }
}

export {
    DayModel
};
